import {addCalendarDays, isoWeekdayForLocalDate, parseLocalDate, type DateTimeFormatter} from '@fitro/date-time'

export type LocalWeekRange = {
    startDate: string
    endDate: string
}

type StudioClock = Pick<DateTimeFormatter, 'today' | 'dateKeyInZone'>

function mondayDateKey(dateKey: string): string {
    return addCalendarDays(dateKey, -(isoWeekdayForLocalDate(dateKey) - 1))
}

function currentWeekStart(dateTime: StudioClock): string {
    return mondayDateKey(dateTime.today())
}

function rangeFromDateKey(dateTime: StudioClock, dateKey: string): LocalWeekRange {
    const current = currentWeekStart(dateTime)
    const selected = mondayDateKey(dateKey)
    const startDate = selected < current ? current : selected
    return {startDate, endDate: addCalendarDays(startDate, 6)}
}

export function getLocalWeekRange(dateTime: StudioClock, date = new Date()): LocalWeekRange {
    return rangeFromDateKey(dateTime, dateTime.dateKeyInZone(date) ?? dateTime.today())
}

export function getLocalWeekRangeFromDateKey(dateTime: StudioClock, dateKey: string | null | undefined): LocalWeekRange {
    return rangeFromDateKey(dateTime, dateKey && parseLocalDate(dateKey) ? dateKey : dateTime.today())
}

export function shiftLocalWeekRange(dateTime: StudioClock, weekRange: LocalWeekRange, weeks: number): LocalWeekRange {
    if (!parseLocalDate(weekRange.startDate)) return getLocalWeekRange(dateTime)
    return rangeFromDateKey(dateTime, addCalendarDays(weekRange.startDate, weeks * 7))
}

export function canShiftLocalWeekRangeBackward(dateTime: StudioClock, weekRange: LocalWeekRange): boolean {
    if (!parseLocalDate(weekRange.startDate)) return false
    return addCalendarDays(weekRange.startDate, -7) >= currentWeekStart(dateTime)
}
